module.exports = __webpack_public_path__ + "img/dummy-profile.6c26dbea.png";